module.exports = __webpack_public_path__ + "4e10b61b1a37d479fedc43e3d393ef73.pdf";